class ApiNotification {
  constructor(props) {
    this.username = String("");
    this.fit_auth_status = Boolean(false);
    this.fit_auth_token = null;

    this.baseurl = String(process.env.REACT_APP_NOTIFICATION_API_URL);
  }


  getNotifications(page = 1) {
    this.requestName = `/notification?page=${page}`;
    return this.httpRequestGet(this.baseurl + this.requestName, null, this.fit_auth_token);
  }


  markAsRead(idNotification) {
    this.requestName = `/notification/read`;
    return this.httpRequestPut(this.baseurl + this.requestName, {idNotification}, this.fit_auth_token);
  }


  markAsDone(notifications, revert = false) {
    this.requestName = `/notification/expire`;
    return this.httpRequestPut(this.baseurl + this.requestName, {notifications, revert}, this.fit_auth_token);
  }


  getNotificationSettings() {
    this.requestName = `/notification/user/settings`;
    return this.httpRequestGet(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }

  updateNotificationSettings(idDomain, status) {
    this.requestName = `/notification/user/settings`;
    return this.httpRequestPut(this.baseurl + this.requestName, {idDomain, status}, this.fit_auth_token);
  }

  getNotificationsUnread() {
    this.requestName = `/notification/unread`;
    return this.httpRequestGet(this.baseurl + this.requestName, {}, this.fit_auth_token);
  }


  // ==========================================================================================
  // BASE HTTP FUNCTIONS
  // ==========================================================================================
  httpRequestPost(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: 'POST',
      //headers: {
      //    'Content-Type':'application/json',
      //    'Authorization': token,
      //    'fit-auth-token': token
      //},
      headers: this.getRequestHeaders(token),
      body: JSON.stringify(requestBody)
    });
  }

  httpRequestPut(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: 'PUT',
      //headers: {
      //    'Content-Type':'application/json',
      //    'Authorization': token,
      //    'fit-auth-token': token
      //},
      headers: this.getRequestHeaders(token),
      body: requestBody ? JSON.stringify(requestBody) : null
    });
  }

  httpRequestGet(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: 'GET',
      //headers: {
      //    'Content-Type':'application/json',
      //    'Authorization': token,
      //    'fit-auth-token': token
      //},
      headers: this.getRequestHeaders(token)
    });
  }

  httpRequestDelete(endpoint, requestBody, token) {
    return fetch(endpoint, {
      method: 'DELETE',
      //headers: {
      //    'Content-Type':'application/json',
      //    'Authorization': token,
      //    'fit-auth-token': token
      //},
      headers: this.getRequestHeaders(token),
      body: JSON.stringify(requestBody)
    });
  }

  setAuthToken(value) {
    this.fit_auth_token = value;
  }

  // 20200611 - auth token
  // auth token - login legacy - XXXXXXXXXXXXXXXXXX
  // auth token - logijn v2 - Token XXXXXXXXXXXXXXXXXX
  getRequestHeaders(token) {
    let result;
    result = {
      'Content-Type': 'application/json',
      'Authorization': ('Token ' + token),
      'fit-auth-token': token
    };
    return result;
  }

}


export default ApiNotification;
